// extracted by mini-css-extract-plugin
export default {"container":"zCCcwThDKolupE_AS534"};